import React from "react";
import { EvtHeader } from "components/header";
import TicketForm from "../form";

export default function CreateTicket () {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Ticket" />
          <div className="max-w-md p-4 lg:p-6">
              <TicketForm />
      </div>
    </div>
  );
};
